export default __webpack_public_path__ + "static/media/carousel4.264f4810.jpg";